import { ClinicUserAvatarFragment } from 'shared/types/graphql';

type UserWithName = Pick<ClinicUserAvatarFragment, 'id' | 'firstName' | 'lastName'>;

export const sortAssignees = (assignees: UserWithName[]): UserWithName[] => {
  return assignees.sort((a, b) => (a.firstName > b.firstName ? 1 : -1));
};

export const buildDirectMessageName = (assignees: UserWithName[], clinicUserId: string): string => {
  const filteredAssignees = assignees.filter((assignee) => assignee.id !== clinicUserId);
  const channelName = sortAssignees(filteredAssignees)
    .map((assignee) => `${assignee.firstName} ${assignee.lastName}`)
    .join(', ');
  return channelName;
};
